import React from 'react'
import { useForm } from 'react-hook-form'
import Form from '@/shared/ui/Form/Form'
import StringInput, { RichTextInput } from '@/shared/ui/Inputs/StringInput'
import Button from '@/shared/ui/Buttons/Button'
import { useNavigate } from 'react-router-dom'
import Editor from 'react-simple-wysiwyg';
import { watch } from 'fs'


function ProjectForm({ defaultData, onSubmit }: any) {
    const navigate = useNavigate();
    const { register, handleSubmit, control, reset } = useForm({ defaultValues: defaultData });
    
    React.useEffect(() => {
        reset(defaultData, { keepDirty: true, keepTouched: true })
    }, [defaultData])
    console.log("control", control)
    return (
        <Form onSubmit={handleSubmit(onSubmit)} style={{ maxWidth: "560px" }}>
            <StringInput label="Название проекта" register={register("title")} />
            <RichTextInput label="Описание проекта" name="description" control={control}/>
            <div className='FormRow'>
                <Button type="button" onClick={()=>navigate(-1)}>
                    Отмена
                </Button>
                <Button type='submit'>
                    Создать проект
                </Button>
            </div>
        </Form>
    )
}

export default ProjectForm;